var _path, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgLampicon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 12,
    height: 16,
    viewBox: "0 0 12 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.19043 2.5C4.53605 2.5 3.19043 3.84562 3.19043 5.5C3.19043 5.77625 3.41418 6 3.69043 6C3.96668 6 4.19043 5.77625 4.19043 5.5C4.19043 4.39687 5.08793 3.5 6.19043 3.5C6.46668 3.5 6.69043 3.27625 6.69043 3C6.69043 2.72375 6.46668 2.5 6.19043 2.5ZM3.6923 14.3491C3.6923 14.4475 3.72137 14.5434 3.77605 14.6253L4.54199 15.7766C4.6348 15.9159 4.79105 15.9997 4.95824 15.9997H7.4223C7.5898 15.9997 7.74605 15.9159 7.83855 15.7766L8.60449 14.6253C8.65887 14.5434 8.68793 14.4472 8.68824 14.3491L8.6898 12.9997H3.69105L3.6923 14.3491ZM6.19043 0C2.99418 0 0.69043 2.59281 0.69043 5.5C0.69043 6.88656 1.20449 8.15156 2.05168 9.11812C2.57168 9.71156 3.3873 10.9556 3.6898 11.9981V12H5.1898V11.9963C5.18949 11.8472 5.1673 11.6991 5.12262 11.5566C4.94793 11 4.40949 9.5325 3.1798 8.12938C2.53793 7.39719 2.1948 6.46844 2.19199 5.5C2.18574 3.19875 4.05668 1.5 6.19043 1.5C8.39605 1.5 10.1904 3.29437 10.1904 5.5C10.1904 6.46781 9.83918 7.40156 9.20137 8.12938C7.97918 9.52344 7.43824 10.9878 7.26074 11.55C7.21493 11.6945 7.19154 11.8452 7.19137 11.9969V12H8.69137V11.9984C8.99387 10.9556 9.80949 9.71156 10.3295 9.11844C11.1764 8.15156 11.6904 6.88656 11.6904 5.5C11.6904 2.4625 9.22793 0 6.19043 0Z",
    fill: "url(#paint0_linear_2633_7574)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_2633_7574",
    x1: 10.2753,
    y1: 21.2972,
    x2: -3.98138,
    y2: 17.4888,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#8731E8"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#4885ED"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgLampicon);
export default __webpack_public_path__ + "static/media/lampicon.4e8bdad45b88fcaa0e5ec7ac65957bbf.svg";
export { ForwardRef as ReactComponent };